import type { AddressSuggestionDto } from "../../../generated/models";

export function formatAddressSuggestion(suggestion: AddressSuggestionDto): string {
  const parts = [
    suggestion.streetAddress,
    suggestion.streetAddress2,
    suggestion.city,
    suggestion.state,
    suggestion.zip,
  ].filter(Boolean);
  return parts.join(", ");
}
